import {Amplify} from 'aws-amplify';
import {generateClient} from 'aws-amplify/api';

if (!process.env.CHAT_APPSYNC_FE_API_KEY || !process.env.CHAT_APPSYNC_FE_URL) {
  throw new Error('CHAT_APPSYNC_FE_API_KEY or CHAT_APPSYNC_FE_URL is not set');
} else {
  Amplify.configure({
    API: {
      GraphQL: {
        defaultAuthMode: 'apiKey',
        apiKey: process.env.CHAT_APPSYNC_FE_API_KEY,
        region: 'eu-west-1',
        endpoint: process.env.CHAT_APPSYNC_FE_URL,
      },
    },
  });
}

export const chatAppSync = generateClient();
